/**
 * Persistent checkbox selection state.
 *
 * Single source of truth — survives DOM replacements (which is the whole
 * point: when SSE pushes a snapshot and we add/remove rows, the user's
 * selection still applies).
 */
export class Selection {
  constructor() {
    this.set = new Set();
    this.listeners = new Set();
  }
  has(hash) { return this.set.has(hash); }
  add(hash) { this.set.add(hash); this._notify(); }
  delete(hash) { this.set.delete(hash); this._notify(); }
  toggle(hash, on) {
    if (on) this.set.add(hash); else this.set.delete(hash);
    this._notify();
  }
  clear() { this.set.clear(); this._notify(); }
  values() { return [...this.set]; }
  size() { return this.set.size; }
  onChange(fn) { this.listeners.add(fn); return this; }
  _notify() { for (const fn of this.listeners) fn(this); }
}
